<template>
	<form class="list-filter" @submit.prevent="searching">
		<ManagingSection
			class="search-by-enter__container"
			size="l"
			:columnCount="2"
		>
			<ManagingBox title="회원번호">
				<InputText
					inputClass="search-by-enter__target"
					mode="number"
					:inputWidth="100"
					inputWidthUnit="%"
					@input="changeValue([{ key: 'idRegister', value: $event }])"
					:propValue="idRegister"
				/>
			</ManagingBox>
			<ManagingBox title="닉네임">
				<input
					class="search-by-enter__target"
					type="text"
					@input="
						changeValue([
							{ key: 'nickname', value: $event.target.value },
						])
					"
					:value="nickname"
				/>
			</ManagingBox>
			<ManagingBox title="이메일">
				<input
					class="search-by-enter__target"
					type="text"
					@input="
						changeValue([
							{ key: 'email', value: $event.target.value },
						])
					"
					:value="email"
				/>
			</ManagingBox>
			<template v-if="pageType !== 'closed'">
				<ManagingBox title="피부타입">
					<select
						class="select form-xs list-filter__select"
						:value="skinType"
						@change="
							changeValue([
								{ key: 'skinType', value: $event.target.value },
							])
						"
					>
						<option
							v-for="item in skinTypeList"
							:key="item.id"
							:value="item.id"
						>
							{{ item.name }}
						</option>
					</select>
				</ManagingBox>
				<ManagingBox title="추천 닉네임">
					<input
						class="search-by-enter__target"
						type="text"
						@input="
							changeValue([
								{
									key: 'recommendNickname',
									value: $event.target.value,
								},
							])
						"
						:value="recommendNickname"
					/>
				</ManagingBox>
				<ManagingBox title="리뷰수">
					<PeriodBox
						inputClass="search-by-enter__target"
						mode="number"
						@change="
							changeValue([
								{
									key: 'reviewCountRange',
									value: [$event.from, $event.to],
								},
							])
						"
						:inputWidth="116"
						:fromValue="reviewCountRange[0]"
						:toValue="reviewCountRange[1]"
					/>
				</ManagingBox>
			</template>
			<ManagingBox title="이름">
				<input
					class="search-by-enter__target"
					type="text"
					@input="
						changeValue([
							{ key: 'userName', value: $event.target.value },
						])
					"
					:value="userName"
				/>
			</ManagingBox>
			<template v-if="pageType !== 'closed'">
				<ManagingBox title="SNS 연동">
					<select
						class="select form-xs list-filter__select"
						:value="sns"
						@change="
							changeValue([
								{ key: 'sns', value: $event.target.value },
							])
						"
					>
						<option
							v-for="item in snsList"
							:key="item.id"
							:value="item.id"
						>
							{{ item.value }}
						</option>
					</select>
				</ManagingBox>
			</template>
			<template v-if="pageType !== 'closed'">
				<ManagingBox title="성별">
					<RadioList
						v-model="gender"
						:radio-list="genderList"
						value-name="name"
						input-class="search-by-enter__target"
					/>
				</ManagingBox>
				<ManagingBox title="나이">
					<PeriodBox
						inputClass="search-by-enter__target"
						mode="number"
						@change="
							changeValue([
								{
									key: 'ageRange',
									value: [$event.from, $event.to],
								},
							])
						"
						:inputWidth="116"
						:fromValue="ageRange[0]"
						:toValue="ageRange[1]"
					/>
				</ManagingBox>
				<ManagingBox title="가입일">
					<DateRange v-model="createDateRange" type="date" />
				</ManagingBox>
				<ManagingBox title="이벤트 당첨 수">
					<PeriodBox
						inputClass="search-by-enter__target"
						mode="number"
						@change="
							changeValue([
								{
									key: 'winCountRange',
									value: [$event.from, $event.to],
								},
							])
						"
						:inputWidth="116"
						:fromValue="winCountRange[0]"
						:toValue="winCountRange[1]"
					/>
				</ManagingBox>
			</template>
			<ManagingBox title="전화번호">
				<InputText
					class="list-filter__user-tel"
					inputClass="search-by-enter__target"
					mode="number"
					placeholder="'-' 없이 입력해주세요"
					@input="changeValue([{ key: 'userTel', value: $event }])"
					:inputWidth="100"
					inputWidthUnit="%"
					:propValue="userTel"
				/>
			</ManagingBox>
			<template v-if="pageType !== 'closed'">
				<ManagingBox title="블라인드 유무">
					<RadioList
						v-model="isBlind"
						:radio-list="isBlindList"
						input-class="search-by-enter__target"
					/>
				</ManagingBox>
				<template v-if="pageType === 'activated'">
					<ManagingBox title="마지막 접속일시">
						<DateRange v-model="lastDateRange" type="date" />
					</ManagingBox>
				</template>
				<template v-if="pageType === 'inactivated'">
					<ManagingBox title="휴면 전환일">
						<DateRange v-model="inactivatedDateRange" type="date" />
					</ManagingBox>
				</template>
			</template>
			<template v-if="pageType === 'closed'">
				<ManagingBox title="탈퇴일">
					<DateRange v-model="closedDateRange" type="date" />
				</ManagingBox>
			</template>
			<ManagingBox v-if="pageType === 'activated'" title="회원 등급">
				<RadioList
					v-model="grade"
					:radio-list="gradeList"
					input-class="search-by-enter__target"
					value-name="name"
				/>
			</ManagingBox>
			<template v-if="pageType === 'activated'">
				<ManagingBox title="인스타그램 카테고리">
					<RadioList
						v-model="instagramCategory"
						:radioList="instaCateList"
						valueName="txt"
					/>
				</ManagingBox>
				<ManagingBox title="인스타그램 연동 여부">
					<RadioList
						v-model="instagramActive"
						:radioList="instagramActiveList"
					/>
				</ManagingBox>
			</template>
			<ManagingBox title="픽플 여부">
				<RadioList
					v-model="isPickple"
					:radioList="isPickpleList"
					input-class="search-by-enter__target"
				/>
			</ManagingBox>
			<template v-if="pageType === 'activated'">
				<ManagingBox
					v-for="item in beautyProfileTypeList"
					:key="item.type"
					:title="item.type"
				>
					<CheckboxList
						v-model="beautyProfileIdList"
						:checkboxList="item.list"
					/>
				</ManagingBox>
                <ManagingBox title="휴대폰 인증 여부">
                    <RadioList
                        v-model="isCertification"
                        :radioList="isCertificationList"
                        input-class="search-by-enter__target"
                    />
                </ManagingBox>
			</template>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button
				class="btn-main blue bordered"
				type="button"
				v-text="'검색값 초기화'"
				@click="init"
			/>
			<button type="submit" class="btn-main blue" v-text="'검색하기'" />
		</div>
	</form>
</template>

<script>
	import moment from 'moment';
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import InputText from '@/components/InputText.vue';
	import RadioList from '@/components/RadioList';
	import PeriodBox from '@/components/PeriodBox.vue';
	import RegionSelector from '@/components/RegionSelector.vue';
	import DateRange from '@/components/DateRange';
	import SearchByEnter from '@/components/extends/SearchByEnter.vue';
	import CheckboxList from '@/components/CheckboxList.vue';
	import { beautyProfileInfo, beautyProfileTypeList } from '@/constants.js';

	export default {
		name: 'ListFilter',
		components: {
			ManagingSection,
			ManagingBox,
			InputText,
			RadioList,
			PeriodBox,
			RegionSelector,
			DateRange,
			SearchByEnter,
			CheckboxList,
		},
		extends: SearchByEnter,
		data() {
			return {
				idRegister: '',
				email: '',
				skinType: null,
				regionObj: {
					region: null,
					location: null,
				},
				recommendNickname: '',
				reviewCountRange: [null, null],
				userName: '',
				sns: null,
				nickname: '',
				gender: null,
				ageRange: [null, null],
				createDateRange: { from: '', to: '' },
				winCountRange: [null, null],
				userTel: '',
				isBlind: null,
				lastDateRange: { from: '', to: '' },
				inactivatedDateRange: { from: '', to: '' },
				closedDateRange: { from: '', to: '' },
				grade: null,
				instagramCategory: null,
				instagramActiveList: [
					{ id: 'all', value: '전체' },
					{ id: 'enable', value: '연동' },
					{ id: 'disable', value: '미연동' },
				],
				instagramActive: null,
				isPickpleList: [
					{ id: null, value: '전체' },
					{ id: true, value: 'Y' },
					{ id: false, value: 'N' },
				],
				isPickple: 'all',
                isCertificationList: [
					{ id: null, value: '전체' },
					{ id: true, value: 'Y' },
					{ id: false, value: 'N' },
                ],
                isCertification: null,
				beautyProfileTypeList,
				beautyProfileIdList: beautyProfileInfo.map(item => item.id),
				wishIdProduct: '',
			};
		},
		computed: {
			...mapState('register', [
				'orderDefault',
				'pageType',
				'keyList',
				'snsList',
				'isBlindList',
				'orderList',
				'order',
				'limit',
				'offset',
			]),
			...mapGetters(['getListAddNull', 'getLimitList']),
			skinTypeList() {
				return this.getListAddNull('skinType', null, '선택');
			},
			genderList() {
				return this.getListAddNull('gender', null, '선택');
			},
			gradeList() {
				return this.getListAddNull('grade', null, '전체');
			},
			instaCateList() {
				return this.getListAddNull('instaCate', null, '전체').map(
					({ id, txt, name }) => ({ id, txt: txt || name })
				);
			},
			limitList() {
				return this.getLimitList(50);
			},
		},
		methods: {
			changeValue(changes) {
				changes.forEach(obj => {
					if (this.hasOwnProperty(obj.key)) this[obj.key] = obj.value;
				});
			},
			setFilter(query) {
				this.keyList.forEach(key => {
					let value = query.hasOwnProperty(key) ? query[key] : null;
					switch (key) {
						case 'idRegister':
						case 'email':
						case 'recommendNickname':
						case 'userName':
						case 'nickname':
						case 'userTel':
						case 'sns':
						case 'instagramCategory':
							this[key] = value;
							break;
						case 'skinType':
						case 'gender':
						case 'isBlind':
							this[key] = isNaN(parseInt(value))
								? null
								: parseInt(value);
							break;
						case 'reviewCountRange':
						case 'ageRange':
						case 'winCountRange':
							value = query.hasOwnProperty(key)
								? query[key]
								: ',';
							this[key] = value.split(',').map(rangeVal => {
								const int = parseInt(rangeVal);
								return isNaN(int) ? null : int.toString();
							});
							break;
						case 'createDateRange':
						case 'lastDateRange':
						case 'inactivatedDateRange':
						case 'closedDateRange':
							value = (
								query.hasOwnProperty(key) ? query[key] : ','
							).split(',');
							this[key] = value.reduce((acc, cur, idx) => {
								acc[idx === 0 ? 'from' : 'to'] = cur;
								return acc;
							}, {});
							break;
						case 'grade':
							value = parseInt(value);
							this[key] = isNaN(value) ? null : value;
							break;
						case 'instagramActive':
							this[key] = value || this[`${key}List`][0].id;
							break;
						case 'beautyProfileIdList':
							this[key] = value ? value.split(',') : [];
							break;
						case 'wishIdProduct':
							this[key] = value;
							break;
						case 'isPickple':
                        case 'isCertification':
							if (value === 'true' || value === true) {
								this[key] = true;
							} else if (value === 'false' || value === false) {
								this[key] = false;
							} else {
								this[key] = null;
							}
							break;
					}
				});
				if (this.pageType !== 'closed') {
					this.regionObj = {
						region: parseInt(query.regionCode) || null,
						location: parseInt(query.locationCode) || null,
					};
				}
				this.$store.commit('register/changeState', [
					{
						key: 'order',
						value: isNaN(Number(query.order))
							? this.orderList[0].id
							: Number(query.order),
					},
					{
						key: 'limit',
						value: isNaN(Number(query.limit))
							? this.limitList[0].id
							: Number(query.limit),
					},
					{
						key: 'offset',
						value: isNaN(Number(query.offset))
							? 0
							: Number(query.offset),
					},
				]);
			},
			getParams() {
				return this.keyList.reduce((acc, key) => {
					const value = this[key];
					if (
						[
							'createDateRange',
							'lastDateRange',
							'inactivatedDateRange',
							'closedDateRange',
						].includes(key)
					) {
						acc[key] = [
							value.from.replaceAll('-', '') || null,
							value.to.replaceAll('-', '') || null,
						];
					} else if (key === 'regionObj') {
						acc['regionCode'] =
							Number(this.regionObj.region) || null;
						acc['locationCode'] =
							Number(this.regionObj.location) || null;
					} else if (value || value === 0) {
						if (Array.isArray(value)) {
							acc[key] = value.map(arrVal => {
								if (arrVal || arrVal === 0) {
									return typeof arrVal === 'object'
										? moment(arrVal).format('YYYYMMDD')
										: arrVal;
								} else {
									return null;
								}
							});
						} else acc[key] = value;
					} else if (key === 'isPickple' || key === 'isCertification') {
						if (value !== null) {
							acc[key] = value;
						}
					}
					return acc;
				}, {});
			},
			setList(query) {
				this.setFilter(_.cloneDeep(query));
				this.$store.dispatch('register/getList', this.getParams());
			},
			init() {
				this.$router
					.push({
						query: {
							order: this.orderDefault,
							limit: 10,
							offset: 0,
						},
					})
					.catch(err => {
						window.location.reload();
					});
			},
			searching() {
				const query = this.keyList.reduce((acc, key) => {
					const value = this[key];
					if (key === 'beautyProfileIdList') {
						acc[key] = value.length ? value.join(',') : '';
					} else if (
						[
							'createDateRange',
							'lastDateRange',
							'inactivatedDateRange',
							'closedDateRange',
						].includes(key)
					) {
						acc[key] = `${value.from},${value.to}`;
					} else if (key === 'regionObj') {
						if (this.regionObj.region && this.regionObj.location) {
							acc.regionCode = this.regionObj.region;
							acc.locationCode = this.regionObj.location;
						}
					} else if (key === 'isPickple' || key === 'isCertification') {
						if (value !== null) {
							acc[key] = value;
						}
					} else if (value || value === 0) {
						if (!Array.isArray(value)) {
							acc[key] = value;
						} else if (value.some(item => item)) {
							acc[key] = value
								.map(arrVal => {
									let returnVal =
										arrVal || arrVal === 0 ? arrVal : null;
									if (
										key.indexOf('DateRange') > -1 &&
										returnVal
									) {
										returnVal = returnVal.getTime();
									} else if (
										key.indexOf('Range') > -1 &&
										returnVal
									) {
										returnVal = Number(returnVal);
									}
									return returnVal;
								})
								.join(',');
						}
					}
					return acc;
				}, {});
				query.order = this.order;
				query.limit = this.limit;
				query.offset = 0;
				this.$router.replace({ query }).catch(err => {
					window.location.reload();
				});
			},
		},
		watch: {
			'$route.query'(query) {
				this.setList(query);
			},
		},
		mounted() {
			this.setList(this.$route.query);
		},
	};
</script>

<style lang="scss" scoped>
	FORM.list-filter {
		.list-filter__select,
		.list-filter__user-tel {
			width: 100%;
		}
	}
</style>
